import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import poster from '@/static/assets/reviews/Annalise_Renters/video.jpg';
import subs from '@/static/assets/reviews/Annalise_Renters/subs.vtt';

export const Annalise: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters],
  reviewerName: 'Annalise',
  videoUrl: `${ASSETS_URL}/renters/Annalise_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
